import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

export default defineNuxtRouteMiddleware(async (to, from) => {
  /**
   * This check prevents `/authenticate` from being called twice
   */
  if (
    to.fullPath === '/check-email' ||
    to.fullPath === '/logout' ||
    to.fullPath === '/open-in-browser' ||
    to.path === '/403' ||
    to.query?.code ||
    to.hash
  ) {
    return;
  }

  const featureFlagsStore = useFeatureFlagsStore();
  const userDetailsStore = useUserDetailsStore();

  const isMagicLinkLoginEnabled = featureFlagsStore.getByFlagName(
    featureFlagSlugs.transportMagicLinkLogin,
  );

  if (isMagicLinkLoginEnabled) {
    await userDetailsStore.getAuthenticatedUserDetails();

    // TEMP (TRA-13576): placeholder block until BE returns a dedicated errorCode for a
    // deleted/restricted account on /authenticate (see useHandleErrorCodes.js). Remove
    // once that ships - accountStatus should be checked there instead.
    const { accountStatus } = userDetailsStore.user ?? {};
    if (accountStatus && accountStatus !== 'active') {
      return navigateTo('/403', { query: { src: 'middleware' } });
    }
  } else {
    await userDetailsStore.getUserDetails();
  }
});
